import React, {useEffect, useState} from 'react';

import SubBody from "../../../application/general/components/common/SubBody";
import {Button, Switch} from "antd";
import {t} from "i18next";
import DG_FormItem_LabelDetail from "../../../../../custom/data-entry/form/Item/LabelDetail";
import {useNavigate} from "react-router-dom";

const SettingGPS = props => {
    const [gps, setGps] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(props.attendanceGPS){
            setGps(props.attendanceGPS)
        }
    },[props.attendanceGPS])


    return (
        <div className={'px-8 py-3'}>
            <SubBody>
                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.setting-gps")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.setting-gps-detail")}
                    labelCol={{xxl: {span: 23}, xl: {span: 23}, lg: {span: 24}}}
                    wrapperCol={{xxl: {span: 1}, xl: {span: 1}, lg: {span: 24}}}
                    name= "attendanceGPS"
                    valuePropName="checked"
                >
                    <Switch onChange={(value ) => setGps(value)} />
                </DG_FormItem_LabelDetail>
                {gps ?
                    <div>
                        <DG_FormItem_LabelDetail
                            label={t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.dot-location-setting-gps")}
                            labelDetail={t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.dot-location-setting-gps-ref")}

                            labelCol={{xxl: {span: 23}, xl: {span: 23}, lg: {span: 24}}}
                            wrapperCol={{xxl: {span: 1}, xl: {span: 1}, lg: {span: 24}}}
                        >
                            <Button
                                type="dashed"
                                onClick={() => navigate("/setting/timekeeping/attendance-locations") }
                            >
                                {t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.setting")}
                            </Button>
                        </DG_FormItem_LabelDetail>
                    </div>
                    : <></>}
            </SubBody>
        </div>
    );
};

SettingGPS.propTypes = {};

export default SettingGPS;
